import React, { useState, useEffect, useContext } from "react";
import Result from "./CardTeaser";
import { GlobalContext } from "./../Context";
import getPostalAbbreviation from "./../Global/getPostalAbbreviation";
import removeQueryParams from "./../Global/removeQueryParams";
import "./CardTeaser.scss";
import { ServiceType } from "../ServiceType";

function ResultsView({ data }) {
  const [cardListState, setCardListState] = useState("close");
  const [sortedBranches, setSortedBranches] = useState([]);
  const [initialTouchClientY, setInitialTouchClientY] = useState(0);
  const globalContext = useContext(GlobalContext);

  const {
    setCurrentPopUp,
    branches,
    setBranches,
    initialPos,
    mapsInstance,
    setMarkersVisibility,
    setResultsState,
    setFiltersVisibility,
    langcode,
    setFilterCardState,
    setBackButtonVisibility,
  } = globalContext;

  useEffect(() => {
    if (mapsInstance) {
      let sortedArray = branches.sort((a, b) => {
        let { google } = mapsInstance;
        let queryCircle = new google.maps.Circle({
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          center: new google.maps.LatLng(initialPos),
          radius: 2000,
        });
        let locationA = new google.maps.LatLng({
          lat: a.fieldCoordinates.lat,
          lng: a.fieldCoordinates.lng,
        });
        let locationB = new google.maps.LatLng({
          lat: b.fieldCoordinates.lat,
          lng: b.fieldCoordinates.lng,
        });
        let markerA = new google.maps.Marker({
          position: locationA,
        });
        let markerB = new google.maps.Marker({
          position: locationB,
        });
        let distanceA = google.maps.geometry.spherical.computeDistanceBetween(
          markerA.getPosition(),
          queryCircle.getCenter()
        );
        let distanceB = google.maps.geometry.spherical.computeDistanceBetween(
          markerB.getPosition(),
          queryCircle.getCenter()
        );
        return distanceA - distanceB;
      });
      setSortedBranches(sortedArray);
    }
  }, [branches, mapsInstance, initialPos]);

  return (
    <div className="card-teaser-list__container">
      <div
        onTouchMove={(event) => {
          const touchEvent = event.touches[0];
          const touchY = touchEvent.clientY;

          if (touchY < initialTouchClientY) {
            setCardListState("open");
          }
        }}
        onTouchStart={(event) => {
          const touchEvent = event.touches[0];
          const touchY = touchEvent.clientY;
          setInitialTouchClientY(touchY);
        }}
        className={`card-teaser-list__content ${
          cardListState === "open" ? "card-teaser-list__content--open" : ""
        }`}
      >
        <ServiceType data={data} isResultView={true} />
        <div className="card-teaser-action-container">
          <button
            className={`card-teaser-list__content__return__button ${
              cardListState === "close"
                ? "card-teaser-list__content__return__button--open"
                : ""
            }`}
            onClick={() => {
              setResultsState(false);
              setBranches([]);
              setFiltersVisibility(true);
              setMarkersVisibility(false);
              setCurrentPopUp(false);
              removeQueryParams();
              setFilterCardState("close");
            }}
          >
            Volver a la búsqueda
          </button>
          <button
            className={`card-teaser-list__content__button ${
              cardListState === "close"
                ? "card-teaser-list__content__button--open"
                : ""
            }`}
            onClick={() => {
              if (cardListState === "close") {
                setCardListState("open");
                setBackButtonVisibility(false);
              } else if (cardListState === "open") {
                setCardListState("close");
                setBackButtonVisibility(true);
              }
            }}
            onTouchMove={(event) => {
              const touchEvent = event.touches[0];
              const touchY = touchEvent.clientY;

              if (touchY > initialTouchClientY) {
                setCardListState("close");
              }
            }}
            onTouchStart={(event) => {
              const touchEvent = event.touches[0];
              const touchY = touchEvent.clientY;
              setInitialTouchClientY(touchY);
            }}
          >
            {cardListState === "close" && (
              <img
                className="card-image"
                src="/modules/custom/bac_locations/js/src/assets/img/list-items.svg"
                alt="List item"
              />
            )}

            {cardListState === "close" ? "Ver resultados" : "Ver mapa"}
            {cardListState !== "close" && (
              <img
                className="card-image"
                src="/modules/custom/bac_locations/js/src/assets/img/location-point.svg"
                alt="location"
              />
            )}
          </button>
        </div>
        <div className="card-teaser-list__cards">
          {sortedBranches.length !== 0 &&
            sortedBranches.map((data, index) => {
              // ToDo: This has too many levels of conplexity and can be simplified.
              return (
                <Result
                  id={`${data.entityLabel
                    .toLowerCase()
                    .replace(/ /g, "")}-${index.toString()}`}
                  key={`result-${index}`}
                  name={data.entityLabel}
                  entityId={data.entityId}
                  type={data.fieldOfficeBranchType}
                  location={data.fieldAddress}
                  date={data.fieldSchedule}
                  dateCounter={data.fieldScheduleCounter}
                  services={
                    data.queryFieldServices !== null
                      ? data.queryFieldServices.entities
                      : ""
                  }
                  coordinates={data.fieldCoordinates}
                  image={data.fieldOfficeBranchImage}
                  deactivateSchedule={data.fieldDesactivarHorario}
                  hasElectricCharger={data.fieldElectricCharger}
                  deactivatePhone={data.fieldDesactivarTelefono}
                  aditionalInfo={data.fieldDisclamer}
                  mobilePhone={data.fieldMobilePhone}
                  principalPhone={data.fieldPrincipalPhone}
                  geographyLocation={
                    data[
                      `fieldGeographyLocation${getPostalAbbreviation(langcode)}`
                    ]
                  }
                  setCardListState={setCardListState}
                  fieldLocation={data.fieldLocation}
                />
              );
            })}
          {sortedBranches.length === 0 && (
            <div className="card-teaser-list-error">
              <p className="place-search__submit-help-text place-search__submit-help-text--error">
                No se han podido encontrar resultados, por favor modifique su
                búsqueda o ingrese una ubicación diferente.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResultsView;
